import { graphql } from "@/graphql/codegen"

graphql(`
  query GetSalesQuoteEmailPreview($quoteGroupId: Int!, $emailNote: String) {
    salesPipeline {
      salesQuoteEmailPreview(quoteGroupId: $quoteGroupId, emailNote: $emailNote) {
        __typename
        ... on SalesQuoteEmailPreviewSuccess {
          preview {
            recipients {
              contactId
              name
              email
            }
            subject
            bodyHtml
            submittedOn
            pricingPath
            canSend
            attachments {
              filename
              signedUrl
            }
          }
        }
        ... on SalesQuoteEmailPreviewFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
